import type { ComponentProps } from 'react'
import { Button } from '@cocoonspace/ui/components/button'
import { useLingui } from '@lingui/react/macro'
import { CheckIcon, PlusIcon } from 'lucide-react'

import {
	type Provider,
	useConnectIntegration,
} from '~/domains/scheduling/event-types/edition/calendar-sync/use-connect-integration.hook'
import { RemoveIntegrationDialog } from './remove-integration-dialog'

export const ConnectBtn = ({
	provider,
	showDeleteButtons = false,
	connected = false,
	...props
}: {
	provider: Provider
	connected?: boolean
	showDeleteButtons?: boolean
} & ComponentProps<typeof Button>) => {
	const { t } = useLingui()

	const { openAuthPopup } = useConnectIntegration({ provider })

	if (connected) {
		return (
			<>
				<span className='ml-auto flex items-center gap-2 text-sm max-md:justify-center'>
					<CheckIcon className='!stroke-[3] text-green-500' />
					<span className='max-md:hidden'>{t`Connecté`}</span>
				</span>

				{showDeleteButtons && <RemoveIntegrationDialog provider={provider} />}
			</>
		)
	}

	return (
		<Button
			size='sm'
			variant='outline'
			onClick={openAuthPopup}
			{...props}
		>
			<PlusIcon />
			<span>{t`Connecter`}</span>
		</Button>
	)
}
